<template>
  <div class="character-choice">
    <div class="container">
      <ChoiceHeader />
    </div>
    <div
      v-if="choices"
      class="choices"
    >
      <Choice
        v-for="(choice, index) in choices"
        :key="index"
        v-bind="choice"
      />
    </div>
    <div class="container">
      <p class="small">Of scroll om verder te gaan</p>
      <svg class="chevron" xmlns="http://www.w3.org/2000/svg" width="27.414" height="8.021"><path d="M25.914 1.5L13.707 6.521 1.5 1.5" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/></svg>
    </div>
  </div>
</template>

<script>
import Choice from './Choice'
import ChoiceHeader from './ChoiceHeader'

export default {
  name: 'CharacterChoice',
  data () {
    return {
      choices: [{
        filename: 'my',
        gender: 'male',
        age: 'young'
      }, {
        filename: 'fy',
        gender: 'female',
        age: 'young',
        base: true
      }, {
        filename: 'mo',
        gender: 'male',
        age: 'old'
      }, {
        filename: 'fo',
        gender: 'female',
        age: 'old'
      }]
    }
  },
  components: {
    Choice,
    ChoiceHeader
  }
}
</script>

<style lang="scss" scoped>
.character-choice {
  padding: 100px 0 20px;
  text-align: center;
}

.choices {
  @extend %clearfix;

  margin: 0 auto;
  padding: 60px 0 50px;
  max-width: 345px;

  @media (min-width: 768px) {
    max-width: 768px;
  }
}

.small {
  font-size: 16px;
}
</style>
